/* global axios */
import ApiClient from './ApiClient';

class ConversationApi extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  vmetalAssistance(id) { return axios.post(`${this.url}/${id}/vmetal_assistance`); }

  startVMetal(id) { return axios.post(`${this.url}/${id}/vmetal_replay`); }

  getVMetal(id, runId) { return axios.get(`${this.url}/${id}/vmetal_replay/${runId}`); }

  getLabels(conversationID) {
    return axios.get(`${this.url}/${conversationID}/labels`);
  }

  updateLabels(conversationID, labels) {
    return axios.post(`${this.url}/${conversationID}/labels`, { labels });
  }

  getUnreadCounts() {
    return axios.get(`${this.url}/unread_counts`);
  }
}

export default new ConversationApi();
